<app-horizontaltopbar></app-horizontaltopbar><br><br><br><br><br>



<div class="d-flex justify-content-center">
  <div class="col-lg-10">
    <div class="card">
      <div class="card-body">
        <p-toast position="bottom-top" />

                     <div class="d-flex justify-content-center p-4  mb-md-2">
                        <h1 class="fs-3">
                            <span>B</span>
                            <span>i</span>
                            <span>e</span>
                            <span>n</span>
                            <span>v</span>
                            <span>e</span>
                            <span>n</span>
                            <span>u</span>
                            <span>e</span> &nbsp;
                            <span>sur</span> &nbsp;
                            <span>la</span> &nbsp;
                            <span>plateforme</span> &nbsp;
                            <span>de</span> &nbsp;
                            <span>Suivi</span> &nbsp;
                            <span>Evaluation</span> &nbsp;

                            <!-- <span>{{referenceUser?.user?.surname}} {{referenceUser?.user?.name}}</span> -->
                         
                        </h1>

                    </div> 
   
          <div class="d-flex justify-content-center flex-wrap">
              <!-- Loop through paginatedExercice to display items inline -->
              <div class="col-4 col-md-2 me-3" *ngFor="let item of paginatedExercice">
                  <div class="year-btn" (click)="accessUser(item.annee)">
                      {{ item.annee }} 
                      <span title="Veuillez cliquer pour accéder à cet exercice" style="background-color: white; border-radius: 50%; padding: 10px; display: inline-block; color: #145045;">
                        <i class="pi pi-arrow-up-right" style="font-size: 1.5rem"></i>
                    </span>
                    
                  </div>
              </div>
          </div>
      
          <!-- Loader displayed during data loading -->
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
              <div class="container">
                  <div class="row">
                      <div class="text-center">
                          <h5 id="graycolor">Chargement en cours</h5>
                          <div class="loader4"></div>
                      </div>
                  </div>
              </div>
          </div>
      <br>
        
      </div>

      <div class="d-flex justify-content-center mt-4">
        <a type="button" (click)="goBack()"  class="btn" style="background-color: transparent; border: 1px solid #ccc; color: #555; padding: 8px 16px; border-radius: 5px;">
          <i class="pi pi-arrow-left" style="font-size: 1.2rem; color: #555;"></i> Retour
        </a>
      </div>
      
      
      <div class="bottom-line"></div>

      </div>
    </div>
  </div>